import { TPagination } from '../../hooks/use-pagination'
import { PaginationContainer } from './styles'
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri'
import { RxDoubleArrowRight, RxDoubleArrowLeft } from 'react-icons/rx'
import { CgPushRight } from 'react-icons/cg'
import { TfiControlShuffle } from 'react-icons/tfi'
import Tooltip from './TooltipQuestions'

interface IProps {
  pagination: TPagination

  bookId: string
  itemsPerPage: number
  isLoading?: boolean
  unanswered(): void
}

const PaginationOfQuestion = (props: IProps) => {
  const { pagination } = props

  const setRandomPage = () => {
    const randomPage = Math.floor(Math.random() * pagination.total) + 1

    pagination.setPage(randomPage)
  }

  return (
    <PaginationContainer>
      <button
        className="prev-question tooltipQuestion"
        disabled={pagination.active === 1 || props.isLoading}
        onClick={pagination.previous}
      >
        {window.innerWidth <= 768 ? (
          <RiArrowLeftSLine size={25} />
        ) : (
          <>
            <Tooltip textTooltip="Questão anterior">
              <RiArrowLeftSLine size={25} />
            </Tooltip>
          </>
        )}
      </button>
      <button
        className="next-question tooltipQuestion"
        onClick={pagination.next}
        disabled={pagination.active === pagination.total || props.isLoading}
      >
        {window.innerWidth <= 768 ? (
          <RiArrowRightSLine size={25} />
        ) : (
          <Tooltip textTooltip="Próxima questão">
            <RiArrowRightSLine size={25} />
          </Tooltip>
        )}
      </button>
      <button
        className="aleatory-question tooltipQuestion"
        onClick={setRandomPage}
        disabled={props.isLoading}
      >
        {window.innerWidth <= 768 ? (
          <TfiControlShuffle size={25} />
        ) : (
          <Tooltip textTooltip="Questão aleatória">
            <TfiControlShuffle size={25} />
          </Tooltip>
        )}
      </button>
      <button
        className="unanswered-question tooltipQuestion"
        onClick={() => props.unanswered()}
        disabled={props.isLoading}
      >
        {window.innerWidth <= 768 ? (
          <CgPushRight size={25} />
        ) : (
          <Tooltip textTooltip="Próxima questão não respondida">
            <CgPushRight size={25} />
          </Tooltip>
        )}
      </button>
      <button
        className="first-question tooltipQuestion"
        onClick={pagination.first}
        disabled={pagination.active === 1 || props.isLoading}
      >
        {window.innerWidth <= 768 ? (
          <RxDoubleArrowLeft size={25} />
        ) : (
          <Tooltip textTooltip="Primeira questão">
            <RxDoubleArrowLeft size={25} />
          </Tooltip>
        )}
      </button>
      <button
        className="last-page tooltipQuestion"
        onClick={pagination.last}
        disabled={pagination.active === pagination.total || props.isLoading}
      >
        {window.innerWidth <= 768 ? (
          <RxDoubleArrowRight size={25} />
        ) : (
          <Tooltip textTooltip="Última questão">
            <RxDoubleArrowRight size={25} />
          </Tooltip>
        )}
      </button>
    </PaginationContainer>
  )
}

export default PaginationOfQuestion
